import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function JoinTheFamily() {
  return <section data-section-id="262844" id="join-the-family" className="w-full bg-background dark">
      <div className="grid grid-cols-1 lg:grid-cols-2 w-full min-h-[500px] lg:min-h-[600px]">
        {}
        <div className="relative w-full h-[400px] lg:h-auto">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/modern_home_architecture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/modern_home_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686387/img/modern_home_architecture.png-wvc-sizes" alt="Modern architectural home with glass walls" className="absolute inset-0 w-full h-full object-cover grayscale opacity-80" loading="lazy" />
        </div>

        {}
        <div className="flex flex-col justify-center items-start p-8 md:p-16 lg:p-20 xl:p-24 bg-background">
          <span className="text-sm font-bold tracking-[0.15em] uppercase mb-4 text-primary font-mono">
            Career Opportunities
          </span>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold uppercase font-default leading-[1.1] mb-6 text-foreground tracking-tight">
            We're Growing. Join Our Team.
          </h2>
          
          <p className="text-lg text-muted-foreground mb-10 max-w-md leading-relaxed font-default">
            Beacon Finance Group is expanding. We are looking for dedicated advisors who value culture, growth, and cutting-edge financial technology.
          </p>
          
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-wider h-14 px-8 rounded-md shadow-lg transition-all duration-300">
            <Link to="/ContactPage">
              View Open Positions
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}